import { Box } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import React, { memo, useState } from 'react';
import { FBTooltip } from '../..';
import { ReactComponent as OutlinedCloneIcon } from '../../../../assets/images/clone.svg';
import { ReactComponent as CloneIcon } from '../../../../assets/images/formBuilder/clone_dark.svg';
import Colors from '../../../layout/theme/utils/colors';
import { FBMPIProcedureProps } from '../FBMPIProcedure.types';

type ActionsProps = Pick<FBMPIProcedureProps, 'disabled' | 'handleAdd'>;

const Actions: React.FC<ActionsProps> = ({
  disabled,
  handleAdd,
}) => {
  const [isHover, setIsHover] = useState(false);
  const [isAddIconHover, setIsHoverAddIcon] = useState(false);

  return (
    <Box display="flex" flexDirection="row-reverse" mb={-2.5} position="relative" zIndex={1}>
      <div
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <FBTooltip title="form.builder.clone.step">
          { isHover
            ? <CloneIcon
              data-cy="form.builder.clone.step"
              onClick={() => handleAdd?.(true)}
              {...{ disabled }}
              style={{ marginLeft: '15px', cursor: 'pointer' }}
            />
            : <OutlinedCloneIcon
              data-cy="form.builder.clone.step"
              onClick={() => handleAdd?.(true)}
              {...{ disabled }}
              style={{ marginLeft: '15px', cursor: 'pointer' }}
            />
          }
        </FBTooltip>
      </div>
      <div
        onMouseEnter={() => setIsHoverAddIcon(true)}
        onMouseLeave={() => setIsHoverAddIcon(false)}
      >
        <FBTooltip title="form.builder.add">
          {isAddIconHover
            ? <AddCircleIcon style={{ color: Colors.almost_black, width: '17px', height: '17px' }}
              data-cy="form.builder.add.step"
              onClick={() => handleAdd?.()}
              {...{ disabled }}
            />
            : <AddCircleOutlineOutlinedIcon style={{ color: Colors.font_gray, width: '17px', height: '17px' }}
              data-cy="form.builder.add.step"
              onClick={() => handleAdd?.()}
              {...{ disabled }}
            />
          }
        </FBTooltip>
      </div>
    </Box>
  );
};

export default memo(Actions);
